import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router'; 

@Component({
    selector: 'app-case-studies-details-page',
    templateUrl: './case-studies-details-page.component.html',
    styleUrls: ['./case-studies-details-page.component.scss']
})
export class CaseStudiesDetailsPageComponent3 implements OnInit {

    constructor(private router: Router) { }

    ngOnInit(): void {
        this.router.events.subscribe((event) => { 
            if (!(event instanceof NavigationEnd)) { 
                return; 
            } 
            window.scrollTo(0, 0) 
        }); 
    }

    pageTitleArea: pageTitle[] = [
        {
            title: 'Case Study: Automated Vehicle Entry and Exit Monitoring',
            subTitle: '1',
        }
    ]

    caseStudiesDetailsDesc: DetailsDesc[] = [
        {
            subTitle: 'Surveillance, Public Safety, Threat Prevention',
            img1: '',
            title1: 'Company Overview',
            paragraph1: 'Best Western Resort and Country Club is spread over 1 million square feet land in a tranquil setting, 45 minutes from Delhi Airport. The management places a high priority on security and has been seeking to improve the efficiency and reliability of its entry and exit monitoring system.',
            title2: 'Problem Statement',
            paragraph2: 'Best Western Resort and Country Club needed a solution to automate the recording of vehicle entries and exits, ensuring accurate and reliable data collection. The existing manual record-keeping system was labor-intensive, prone to errors, and required a security guard to be present round the clock. Objective was to implement an AI-powered camera system to capture license plates of vehicles entering and exiting the property, generate detailed reports, and alert security if barred vehicles attempt to enter.',
            title3: 'Solution',
            paragraph3: 'Best Western Resort and Country Club partnered with Awareye in mid 2024 to deploy an advanced license plate recognition system at the main entrance gate, designed to automate record-keeping and enhance security.',
            title4: 'Implementation',
            title5: 'Results',
            title6: "Conclusion",
            paragraph6: 'The implementation of Awareye’s license plate recognition system at Best Western Resort and Country Club significantly improved the efficiency and reliability of vehicle entry and exit monitoring. The automated system provided enhanced security, reduced operational costs, and ensured accurate record-keeping. This successful deployment demonstrates the effectiveness of AI-driven solutions in automating surveillance tasks and improving security in residential communities.',
        }
    ]
    ImplementationDetails: BulletPointDetails[] = [
        {
            title: 'System Design and Integration:',
            details: [
                'Cameras: High-resolution, dual-angle, night-vision enabled cameras were installed at the entrance gate to capture both front and back license plates of vehicles. Cameras were strategically placed to get a clear view of license plates, accounting for vehicles without front plates.',
                'Speed Control: A speed bump was installed at the entrance to slow down vehicles, ensuring the cameras could capture clear images of the license plates.',
                'AI Model Training: Awareye AI trained models to accurately read and record license plates, even in varying lighting conditions and at different speeds.'
            ]
        },
        {
            title: 'Monitoring Process',
            details: [
                'License Plate Recognition: Cameras captured images of entering and exiting vehicles. The AI system processed these images to read the license plates and stored them along with vehicle pictures, entry/exit timestamps, and additional metadata.',
                'Database Integration: The system was integrated with a preconfigured database of barred license plates. If a barred vehicle attempted to enter, the system alerted security personnel via a dedicated mobile app and dashboard.'
            ]
        },
        {
            title: 'Reporting and Alerts',
            details: [
                'Downloadable Reports: The system generated downloadable PDF reports containing license plate numbers, vehicle pictures, and entry/exit timestamps. These reports were available for review and could be customized based on date and time ranges.',
                'Real-Time Alerts: Alerts were sent in real-time to security personnel if a barred vehicle attempted entry, enabling immediate intervention.'
            ]
        }
    ]
    ResultDetails: BulletPointDetails[] = [
        {
            title: 'Enhanced Security:',
            details: [
                'Automated monitoring provided 24x7 surveillance, significantly reducing the risk of unauthorized vehicles entering the property.',
                'Real-time alerts ensured prompt action against barred vehicles, enhancing overall security.'
            ]
        },
        {
            title: 'Operational Efficiency',
            details: [
                'The automated system eliminated the need for a security guard to be present at the entrance gate round the clock, reducing labor costs.',
                'Accurate and reliable data collection minimized errors and improved record-keeping.'
            ]
        },
        {
            title: 'Cost Savings',
            details: [
                'Reduced reliance on human personnel for monitoring led to substantial cost savings for the resort country club.',
                'The investment in AI-powered cameras and software proved to be cost-effective in the long term.'
            ]
        }
    ]
    caseStudiesDetailsInfo: Info[] = [
        {
            icon: 'bx bx-user-pin',
            title: 'Client',
            subTitle: 'Best Western Resort & Country Club',
        },
        {
            icon: 'bx bx-globe',
            title: 'Website',
            subTitle: 'https://resortcountryclub.com',
        },
        {
            icon: 'bx bx-map',
            title: 'Location',
            subTitle: 'Pachgaon, Major District Road 132, near Manesar, Gurugram, Haryana 122015, India',
        },
        {
            icon: 'bx bx-purchase-tag',
            title: 'Industry',
            subTitle: 'Hospitality',
        },
        {
            icon: 'bx bx-check',
            title: 'Started',
            subTitle: 'June 2024',
        }
    ]

}
class pageTitle {
    title : string;
    subTitle : string;
}
class DetailsDesc {
    subTitle : string;
    title1 : string;
    title2 : string;
    title3 : string;
    title4 : string;
    title5 : string;
    title6 : string;
    img1 : string;
    paragraph1: string;
    paragraph2: string;
    paragraph3: string;
    paragraph6: string;
}
class BulletPointDetails {
    title : string;
    details : string[];
}
class Info {
    icon : string;
    title : string;
    subTitle : string;
}